export default {"src":"/_next/static/media/ic-pin.ae307e0c.svg","height":21,"width":16,"blurWidth":0,"blurHeight":0};